import { BASE_API } from '../config'
import { PageDetail, CFG, SdkDetail } from '../types/globals'
import Base64 from './base64'
import { parseTokenDraft } from './utils'
const base64 = new Base64('altihex')

export function getDsl(id: string): Promise<PageDetail> {
    const sign = parseTokenDraft({ cdnKey: id })
    return new Promise((resolve, reject) => {
        fetch(`${BASE_API}/pageDetail?cdnKey=${id}&sign=${sign}`).then(res => res.json()).then(data => {
            if (data.code === 200 && data.data && data.data.id) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch(() => reject())
    })

}

export function getSDK(version: string): Promise<SdkDetail> {
    const sign = parseTokenDraft({ version })
    return new Promise((resolve, reject) => {
        fetch(`${BASE_API}/sdkDetail?version=${version}&sign=${sign}`).then(res => res.json()).then(data => {
            if (data.code === 200 && data.data && data.data.id) {
                resolve(data.data)
            } else {
                reject()
            }
        }).catch(() => reject())
    })
}

export function send(arg: PageDetail, user: any = {}): void {
    const info = base64.encode(JSON.stringify(
        {
            pageId: arg.id,
            type: 1,
            content: {
                url: window.location.href,
                referrer: document.referrer,
                ua: window?.navigator?.userAgent,
                ...arg,
                ...user
            }
        }
    ))
    const sign = parseTokenDraft({
        info
    })
    const img = new Image()
    img.src = `${BASE_API}/access?sign=${sign}&info=${info}`
    // const headers = new Headers();
    // headers.append("Content-Type", "application/json");
    // fetch(`${BASE_API}/access`, {
    //     body: JSON.stringify(params),
    //     method: 'GET',
    //     headers
    // })
}
export function pv(cfg: CFG) {
    if(cfg.headers && cfg.headers.backstagecode && cfg.headers.accesstoken){
        getUser(cfg.headers.backstagecode, cfg.headers.accesstoken).then((data => {
            send(cfg.page as PageDetail, data)
        })).catch(() =>  send(cfg.page as PageDetail, {}))
    }else {
        send(cfg.page as PageDetail, {})
    }
}

export function getUser(backstagecode: string, accesstoken: string): Promise<any> {

    const sign = parseTokenDraft({})

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("backstagecode", backstagecode);
    headers.append("accesstoken", accesstoken);
    return new Promise((resolve, reject) => {
        fetch(`/api/v1/h5/luna/user/getLoginUser?sign=${sign}`, {
            method: 'GET',
            headers
        }).then(res => res.json()).then(data => {
            if(data.code === 200 && data.data && data.data.username){
                resolve({
                    username: data.data.username,
                    name: data.data.realname
                })
            }else {
                resolve({})
            }
        }).catch(() => resolve({}))
    })
}